import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { Box, Container } from '@mui/system';
import Grid from '@mui/system/Grid';

export  default function F04() {
  const navigate = useNavigate();
  const loation = useLocation()

  const navigateHome = ()=>{
    navigate('/home');
  }
  
  return (
    <>
    
    <Container>
        <div className="thankyou parentdiv f04">
             <Box sx={{ flexGrow: 1 }}>
             {/* display:"flex", justifyContent:"center", flexWrap:"nowrap", flexDirection:"row" */}
             <Grid item xs={12} md={12} sx={{flexDirection:"row"}} className="heading">  
                <h1>404</h1>
             </Grid>
<Grid item xs={12} md={12}  sx={{flexDirection:"row", justifyContent:"center"}}>
<h2>Page not found</h2>
<h2><span style={{width:"40px", display:"inline-block", paddingRight:"5px"}}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8 11V9a1 1 0 0 1 2 0v2a1 1 0 0 1-2 0zm7 1a1 1 0 0 0 1-1V9a1 1 0 0 0-2 0v2a1 1 0 0 0 1 1zm-3 2a6.036 6.036 0 0 0-4.775 2.368 1 1 0 1 0 1.55 1.264 4 4 0 0 1 6.45 0 1 1 0 0 0 1.55-1.264A6.036 6.036 0 0 0 12 14zm11-2A11 11 0 1 1 12 1a11.013 11.013 0 0 1 11 11zm-2 0a9 9 0 1 0-9 9 9.01 9.01 0 0 0 9-9z"/></svg></span> Sorry, the page 
{/* <span className="searchpath">{loation.pathname}</span>  */}
you're looking  for cannot be accessed
  </h2>
  
  <p>
    <button onClick={navigateHome} className="btn btn-lg ml-20"><span>Home</span></button>
  </p>


</Grid>
{/* <Grid className="svgLogo" xs={12} md={12} sx={{flexDirection:"row",justifyContent:"center", display:"flex"}}>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8 11V9a1 1 0 0 1 2 0v2a1 1 0 0 1-2 0zm7 1a1 1 0 0 0 1-1V9a1 1 0 0 0-2 0v2a1 1 0 0 0 1 1zm-3 2a6.036 6.036 0 0 0-4.775 2.368 1 1 0 1 0 1.55 1.264 4 4 0 0 1 6.45 0 1 1 0 0 0 1.55-1.264A6.036 6.036 0 0 0 12 14zm11-2A11 11 0 1 1 12 1a11.013 11.013 0 0 1 11 11zm-2 0a9 9 0 1 0-9 9 9.01 9.01 0 0 0 9-9z"/></svg>

</Grid> */}

</Box>
</div>
</Container>
    </>
  )
}

